/**
 * Garde-fou d'origine.
 *
 * Le front est deployable sur deux hotes : le domaine personnalise
 * `camellie.mecantek.ca`, et l'URL technique `*.pages.dev` que Cloudflare
 * attribue au projet Pages. Ils ne se valent pas du tout :
 *
 *  - sur le domaine personnalise, la route `camellie.mecantek.ca/api/*` du
 *    Worker intercepte les appels d'API ;
 *  - sur `pages.dev`, cette route n'existe pas. Pages repond son `index.html`
 *    a tout, y compris a `/api/membres` — un 200 avec du HTML. L'app se
 *    charge, s'affiche, et echoue au premier appel.
 *
 * Le cookie de session est lui aussi lie a l'hote : une session ouverte sur
 * `pages.dev` ne vaudrait rien sur le domaine personnalise.
 *
 * Installer l'app depuis la mauvaise URL produit donc une PWA durablement
 * cassee sur l'ecran d'accueil, sans rien d'evident a l'ecran. On redirige
 * plutot que d'afficher une erreur : l'utilisateur n'a pas a savoir que deux
 * hotes existent.
 */

/** Le seul hote ou l'app fonctionne reellement. */
export const HOTE_CANONIQUE = 'camellie.mecantek.ca';

/**
 * Redirige si on tourne sur une URL technique de Cloudflare Pages.
 *
 * On ne teste que `.pages.dev`, jamais l'inverse : localhost, 127.0.0.1 et
 * toute adresse de developpement doivent passer sans rien faire.
 *
 * @returns true si une redirection a ete declenchee — l'appelant doit alors
 *          s'abstenir de monter l'application.
 */
export function redirigerVersHoteCanonique(): boolean {
  const hote = window.location.hostname;
  if (!hote.endsWith('.pages.dev')) return false;

  const cible = new URL(window.location.href);
  cible.protocol = 'https:';
  cible.host = HOTE_CANONIQUE;
  // `replace` et non `assign` : l'URL pages.dev ne doit pas rester dans
  // l'historique, sinon le bouton retour y ramene.
  window.location.replace(cible.toString());
  return true;
}
